module.exports = __webpack_public_path__ + "static/icons/icon-heart-outline-ea113dfd9ec419d9f4b3d5ab1c64a2af.svg";